import { useMantineTheme } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useErrorMessages } from '@/constants/content'
import useSessionStorage from '@/hooks/useSessionStorage'
import { GOV_INFO_CONTENT_TYPE, RichText } from '@/plugins/contentful/api'
import client from '@/plugins/contentful/client'

import ParseRichText from '../Contentful/ParseRichText'
import CustomAlert from '../CustomAlert'
import ErrorMessage from '../ErrorMessage'
import Loading from '../Loading'

interface GovInfoProps {}

const GovInfo: React.FC<GovInfoProps> = () => {
  const theme = useMantineTheme()
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const errorMessages = useErrorMessages()
  const [title, setTitle] = useSessionStorage<string>(`govInfoTitle-${language}`)
  const [body, setBody] = useSessionStorage<RichText>(`govInfoBody-${language}`)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string>('')
  useEffect(() => {
    if (!body && !title) {
      setIsLoading(true)
      client
        .getEntries({
          content_type: GOV_INFO_CONTENT_TYPE,
          locale: language,
        })
        .then(response => {
          setTitle(response?.items[0]?.fields?.title as string)
          setBody(response?.items[0]?.fields?.body as RichText)
        })
        .catch(err => {
          console.warn(err)
          setError(err.message)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [body, title, setTitle, setBody, t, language])
  return (
    body && (
      <CustomAlert
        style={{ gap: '10px', padding: '5px 10px' }}
        title={title || ''}
        color={theme.colors.title[0]}
        icon={<IconInfoCircle size={18} />}
      >
        {isLoading && <Loading />}
        {error && <ErrorMessage message={errorMessages.cmsConnection} details={error} />}
        {!isLoading && !error && <ParseRichText jsonData={body} noParagraphSpace />}
      </CustomAlert>
    )
  )
}

export default GovInfo
